const InputHeader = ({headerStr}) => {
  return (
    <>
      <h4 className={`rb14m c-black10 headerInput`} style={{ marginBottom: 4 }}>
        {headerStr}        
      </h4>
    </>
  );
};
export default InputHeader;
